import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div>

<section className="hero is-medium">
      <div className="hero-body">
        <div className="container">
          <h1 className="title has-text-centered">
          HOW IT WORKS
          </h1>
          <nav className="level">
            <div className="level-item has-text-centered">
              <div className="wrap-text">
                <h1 className="big-number">1.</h1>
                <h2 className="has-text-weight-bold header is-size-4 has-vert-space">
                  Claim Your Unit
                </h2>
                <p className="has-bottom-margin">
                Follow the sign-up process in our app to get your home ready for short-term rentals.
                </p>
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div className="wrap-text">
               <h1 className="big-number">2.</h1>
                <h2 className="has-text-weight-bold has-vert-space header is-size-4">
                  Open Your Calendar
                </h2>
                <p className="has-bottom-margin">
                Going away? Unblock dates within the app to activate your property on booking platforms.
                </p>
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div className="wrap-text">
                <h1 className="big-number">3.</h1>
                <h2 className="has-text-weight-bold has-vert-space header is-size-4">
                  Sit Back & Relax
                </h2>
                <p className="has-bottom-margin">
                  Let us take care of everything with our fully managed solution, while you enjoy your time away.
                </p>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </section>

    <section className="hero is-fullheight has-bg-img-2">
    <div className="yellow-block flip-horizontal" />
      <div className="hero-body">
        <div className="container has-text-right">
          <h1 className="title is-spaced">HOW MUCH COULD YOU EARN?</h1>
          <p className="subtitle">One Bedroom £68 - £92/night</p>
          <p className="subtitle">Two Bedroom £85 - £115/night</p>
          <p className="subtitle">Three Bedroom £111 - £150/night</p>

          <a href="https://home.lavanda.app/onboarding/signup/oneeighty" className="button is-large">
            Claim Your Unit
          </a>
        </div>
      </div>
    </section>

    <section className="hero is-medium is-primary">
      <div className="hero-body">
        <div className="container">
          <nav className="level">
            <div className="level-item has-text-centered">
              <div className="wrap-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                >
                  <g
                    class="nc-icon-wrapper"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    transform="translate(0.5 0.5)"
                    fill="#ffffff"
                    stroke="#ffffff"
                  >
                    <path
                      d="M22.3,9a7,7,0,1,0,0,6H28l3,2,3-2h5l1-6Z"
                      fill="none"
                      stroke-miterlimit="10"
                      data-color="color-2"
                    />
                    <path
                      d="M9,26h2a9.583,9.583,0,0,1,8,4h6a6.621,6.621,0,0,1,6,6H17"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      data-cap="butt"
                    />
                    <path
                      d="M29.2,32H39a6.074,6.074,0,0,1,6,4L23.8,43.7a9.45,9.45,0,0,1-5-.2L9,38.9"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      data-cap="butt"
                    />
                    <rect
                      x="3"
                      y="24"
                      width="6"
                      height="16"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                    />
                    <circle
                      cx="15"
                      cy="12"
                      r="2"
                      data-cap="butt"
                      data-color="color-2"
                      data-stroke="none"
                      stroke="none"
                    />
                  </g>
                </svg>
                <h2 className="has-text-weight-bold header is-size-4 has-vert-space">
                  Hassle-Free Hosting
                </h2>
                <p className="has-bottom-margin">
                  Our fully managed short-term rental solution allows you to
                  host guests, 100% hassle free!
                </p>
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div className="wrap-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                >
                  <g
                    class="nc-icon-wrapper"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    transform="translate(0.5 0.5)"
                    fill="#ffffff"
                    stroke="#ffffff"
                  >
                    <path
                      data-cap="butt"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      d="M8,26h3c3.284,0,6.3,1.462,8,4h6 c2.907,0,6,3.093,6,6H17"
                    />{' '}
                    <path
                      data-cap="butt"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      d="M29.176,32H39c4.833,0,6,4,6,4 l-21.203,7.746c-1.647,0.392-3.37,0.33-4.985-0.18L8,39"
                    />{' '}
                    <circle
                      data-color="color-2"
                      fill="none"
                      stroke-miterlimit="10"
                      cx="33"
                      cy="19"
                      r="5"
                    />{' '}
                    <circle
                      data-color="color-2"
                      fill="none"
                      stroke-miterlimit="10"
                      cx="19"
                      cy="9"
                      r="5"
                    />{' '}
                    <rect
                      x="2"
                      y="24"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      width="6"
                      height="16"
                    />
                  </g>
                </svg>
                <h2 className="has-text-weight-bold has-vert-space header is-size-4">
                  Lower Your Cost Of Living
                </h2>
                <p className="has-bottom-margin">
                  Use short-term rentals as a way to earn some extra money to
                  help pay for your time away!
                </p>
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div className="wrap-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                >
                  <g
                    class="nc-icon-wrapper"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    transform="translate(0.5 0.5)"
                    fill="#ffffff"
                    stroke="#ffffff"
                  >
                    <polyline
                      data-cap="butt"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      points="34,11 22,3 10,11 "
                    />{' '}
                    <polyline
                      data-cap="butt"
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      points="27,39 2,39 2,11 42,11 42,20.071 "
                    />{' '}
                    <line
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      x1="10"
                      y1="21"
                      x2="24"
                      y2="21"
                    />{' '}
                    <line
                      fill="none"
                      stroke="#ffffff"
                      stroke-miterlimit="10"
                      x1="10"
                      y1="29"
                      x2="18"
                      y2="29"
                    />{' '}
                    <polyline
                      data-cap="butt"
                      data-color="color-2"
                      fill="none"
                      stroke-miterlimit="10"
                      points="44,32.292 44,45 38,42 32,45 32,32.292 "
                    />{' '}
                    <circle
                      data-color="color-2"
                      fill="none"
                      stroke-miterlimit="10"
                      cx="38"
                      cy="27"
                      r="8"
                    />
                  </g>
                </svg>
                <h2 className="has-text-weight-bold has-vert-space header is-size-4">
                  Approved Partner
                </h2>
                <p className="has-bottom-margin">
                  One Eighty short-term rentals has been fully approved and
                  enabled by your building management!
                </p>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </section>

    <section className="hero is-fullheight has-bg-img-3">
      <div className="yellow-block" />
      <div className="hero-body">
        <div className="container">
        <div className="diamond-container">
        <h1 className="title is-1 is-spaced">YOUR SHORT TERM RENTAL SERVICE</h1>
        <h2 className="subtitle is-4 is-spaced">
          Earn extra income from your home while you are away with One Eighty’s
          brand new short-term rental service.
        </h2>
        <a href="https://home.lavanda.app/onboarding/signup/oneeighty" className="button is-large">Get Started Today</a>
      </div>
        </div>
      </div>
    </section>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js